
const errorNoRetryStepConfig = {
    component: () => import('./ErrorNoRetry'),
    hideCartLink: true,
    hidePromoBanner: true
};

export default errorNoRetryStepConfig;
